import React, { Component,createRef }  from 'react';

const fileRef = createRef();
class NuevaCamara extends Component {
    constructor({ parentHandleImage, capture}) {
        super();
        console.log("props: ", parentHandleImage);
        console.log("props: ", capture);
    }

    /**
     * @description dispara la apertura de la camara. Atención, el input file solo puede ser disparado por acciones del usauario.
     */
    handleClick = () => {
        console.log("NuevaCamara.handleClick() | fileRef : ", fileRef);
        fileRef.current.click();
        console.log("Click() hecho");
    };

    handleChange = (e) => {
        console.log("NuevaCamara.handleChange() | evento: ", e);
        const file = e.target.files[0];
        if(this.props.parentHandleImage) {
            console.log("this.props.parentHandleImage ", this.props.parentHandleImage);
            this.props.parentHandleImage(e.target.files[0])
        }
    };

    render(){
        return (
            <input
                type="file"
                ref={fileRef}
                onChange={this.handleChange}
                accept="image/*"
                capture={this.props.capture == 'user'? 'user' : "camera"}
                id="camera"
            />
        )
    }
}

export default NuevaCamara;


// WEBPACK FOOTER //
// ./src/components/OnBoarding/NuevaCamara.js